import { PeriodProvider } from "@/providers/Period";
import { ListNumbersIcon } from "@phosphor-icons/react";
import AuditOrdersProvider from "./AuditoriaPedidos/context/AudOrders";
import { lazy } from "react";

const AuditoriasDashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.AuditoriasDashboard })));
const GestaoInventario = lazy(() => import("./GestaoInventario"));
const ModalItemsOrders = lazy(() => import("./AuditoriaPedidos/components/ModalItensDetails"));
const AuditoriaPedidos = lazy(() => import("./AuditoriaPedidos"));
const GeracaoAuditoria = lazy(() => import("./GeracaoAuditoria"));
const GestaoAuditoria = lazy(() => import("./Gestao1"));


const Module = {
  menuItem: {
    to: "/auditoria",
    title: "Auditoria",
    icon: ListNumbersIcon,
    id: 13,
    childrens: [
      {
        to: "/auditoria/gestao-auditoria",
        title: "Gestao ",
        fullTitle: "Gestao",
        id: 33,
      },
      {
        to: "/auditoria/geracao",
        title: "Geração",
        fullTitle: "Geração",
        id: 34,
      },
      {
        to: "/auditoria/gestao-inventario",
        title: "Gestão Inventario",
        fullTitle: "Gestão Inventario",
        id: 36,
      },
      {
        to: "/auditoria/auditoria-pedidos",
        title: "Auditoria de Pedidos",
        fullTitle: "Gestão Pedidos",
        id: 42,
      },
    ],
  },

  routes: [
    {
      path: "auditoria",
      element: <AuditoriasDashboard />,
    },
    {
      path: "/auditoria/gestao-auditoria",
      element: (
        <PeriodProvider>
          <GestaoAuditoria />
        </PeriodProvider>
      ),
    },
    {
      path: "/auditoria/geracao",
      element: (
        <PeriodProvider>
          <GeracaoAuditoria />
        </PeriodProvider>
      ),
      childrens: [
        { path: "novo", element: <GeracaoAuditoria /> },
      ],
    },
    {
      path: "/auditoria/gestao-inventario",
      element: (
        <GestaoInventario />
      ),
    },
    {
      path: "/auditoria/auditoria-pedidos",
      element: (
        <PeriodProvider>
          <AuditOrdersProvider>
            <AuditoriaPedidos />
          </AuditOrdersProvider>
        </PeriodProvider>
      ),
      children: [
        {
          path: ":id/itens",
          element: <ModalItemsOrders />
        }
      ]
    },
  ],
};

export default Module;
